module.exports = __webpack_public_path__ + "static/media/backframe.0fb680e2.jpg";